export enum Permission {
  StorefrontOnboarding = 'storefront_onboarding.modify',
  MobileAppSecretsView = 'mobile_app_secrets.view',
  StorefrontOnboardingAdminStorefrontSetupView = 'storefront_onboarding_admin_storefront_setup.view',
  StorefrontOnboardingAdminStorefrontSetupModify = 'storefront_onboarding_admin_storefront_setup.modify',
}
